import en from './en';
import fr from './fr';
import de from './de';
import ar from './ar';
import it from './it';
import pr from './pr';
import cn from './cn';
import uk from './uk';
import ur from './ur';

export default {
    ...en,
    ...fr,
    ...de,
    ...ar,
    ...it,
    ...pr,
    ...cn,
    ...uk,
    ...ur,
};
